<template>
  <div :class="{disabled}">
    <v-slide-x-transition group>
      <template v-for="(node, index) in nodes">
        <div
          v-if="node.children && node.children.length"
          :key="`group-${index}`"
        >
          <v-list
            class="py-0"
            nav
            dense
            style="background-color: unset; color: var(--accent)"
          >
            <v-list-item
              class="my-1"
              link
              :input-value="node.value === value"
              @click="$emit('input', node.value)"
            >
              <v-list-item-icon
                v-if="!hideFavorite"
                class="mr-2"
                @click.stop="$emit('favorite', node)"
              >
                <z-icon style="width: 100%; margin-bottom: 2px" size="15">
                  {{ node.favorite ? '$star_rounded' : '$star' }}
                </z-icon>
              </v-list-item-icon>

              <v-list-item-icon class="mr-3" @click.stop="isOpened = !isOpened">
                <z-icon size="15" style="margin-bottom: 2px !important">
                  {{
                    isOpened
                      ? '$keyboard_arrow_down_rounded'
                      : '$keyboard_arrow_right_rounded'
                  }}
                </z-icon>
              </v-list-item-icon>

              <v-list-item-title>
                {{ node.text }}
              </v-list-item-title>

              <v-list-item-action v-if="node.value === value">
                <z-icon size="15"> $check_rounded </z-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list>

          <v-expand-transition>
            <nested-list
              v-show="isOpened"
              class="py-0 pl-3"
              :hide-favorite="hideFavorite"
              :value="value"
              :level="level + 1"
              :nodes="node.children"
              @favorite="$emit('favorite', $event)"
              @input="$emit('input', $event)"
            ></nested-list>
          </v-expand-transition>
        </div>

        <v-list
          v-else
          :key="`tile-${index}`"
          class="py-0 my-1"
          nav
          dense
          style="background-color: unset; color: var(--accent)"
        >
          <v-slide-x-transition>
            <v-list-item
              link
              :input-value="node.value === value"
              @click="$emit('input', node.value)"
            >
              <v-list-item-icon
                v-if="!hideFavorite"
                class="mr-2"
                @click.stop="$emit('favorite', node)"
              >
                <z-icon style="width: 100%; margin-bottom: 4px" size="15">
                  {{ node.favorite ? '$star_rounded' : '$star' }}
                </z-icon>
              </v-list-item-icon>

              <v-list-item-icon class="mr-3">
                <z-icon size="15" style="margin-bottom: 4px !important"
                  >$subdirectory_arrow_right_rounded</z-icon
                >
              </v-list-item-icon>

              <v-list-item-title>
                {{ node.text }}
              </v-list-item-title>

              <v-list-item-action v-if="node.value === value">
                <z-icon size="15"> $check_rounded </z-icon>
              </v-list-item-action>
            </v-list-item>
          </v-slide-x-transition>
        </v-list>
      </template>
    </v-slide-x-transition>
  </div>
</template>

<script>
export default {
  name: 'NestedList',
  props: {
    nodes: {
      type: Array,
      default: () => [],
    },

    level: {
      type: Number,
      default: 0,
    },

    value: {
      type: [String, Number],
      default: 0,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    hideFavorite: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isOpened: true,
    }
  },
}
</script>

<style lang="scss" scoped>
.disabled {
  opacity: 0.5;
  pointer-events: none;
}
</style>
